<template>
  <!-- Retorno de 18/10 (card 17trt6jcyfb): o professor ve os exercicios da
       aula para saber do que tratam e passar aos alunos. Ja vem com o
       gabarito e e so leitura: nada aqui e respondido. Some quando a aula
       nao tem questionario vinculado. -->
  <section v-if="sets.length" class="lak" :class="{ 'is-open': open }">
    <button
      type="button"
      class="lak__toggle"
      :aria-expanded="String(open)"
      aria-controls="lak-body"
      @click="open = !open"
    >
      <span class="lak__title">
        <i class="mdi mdi-pencil-outline" aria-hidden="true"></i>
        {{ $t("exercises.lessonTitle") }}
      </span>
      <span class="lak__count">
        {{ $tc("exercises.keyCount", totalCount, { count: totalCount }) }}
      </span>
      <i
        class="mdi lak__chev"
        :class="open ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        aria-hidden="true"
      ></i>
    </button>

    <div v-show="open" id="lak-body" class="lak__body">
      <p class="lak__hint">{{ $t("exercises.keyHint") }}</p>

      <div v-for="group in sections" :key="group.section" class="lak__section">
        <p class="lak__setname">{{ sectionLabel(group.section) }}</p>

        <article
          v-for="exercise in group.exercises"
          :key="exercise.id"
          class="lak__ex"
          :class="{ 'is-open': openId === exercise.id }"
        >
          <button
            type="button"
            class="lak__row"
            :aria-expanded="String(openId === exercise.id)"
            @click="toggleExercise(exercise.id)"
          >
            <span class="lak__info">
              <span class="lak__prompt">{{
                exercise.prompt || $t("exercises.exercise")
              }}</span>
              <span class="lak__meta">
                {{ exercise.setTitle }} ·
                {{
                  $tc("exercises.questions", exercise.items.length, {
                    count: exercise.items.length,
                  })
                }}
              </span>
            </span>
            <i
              class="mdi lak__chev"
              :class="
                openId === exercise.id ? 'mdi-chevron-up' : 'mdi-chevron-down'
              "
              aria-hidden="true"
            ></i>
          </button>

          <div v-if="openId === exercise.id" class="lak__paper">
            <p v-if="exercise.translation" class="lak__translation">
              {{ exercise.translation }}
            </p>
            <exercise-media :media="exercise.media" />
            <exercise-sheet :exercise="exercise" mode="key" />
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import pitchPartnerApi from "@/shared/pitchPartnerApi";
import ExerciseSheet from "./ExerciseSheet.vue";
import ExerciseMedia from "./ExerciseMedia.vue";

export default {
  name: "LessonAnswerKey",
  components: { ExerciseSheet, ExerciseMedia },
  props: {
    courseClassId: { type: String, required: true },
  },
  data() {
    return { sets: [], open: false, openId: null };
  },
  computed: {
    // A API ja devolve na ordem das secoes; aqui so junta os questionarios
    // da mesma secao, como no bloco do aluno (LessonExercises).
    sections() {
      const groups = [];
      for (const set of this.sets) {
        const section = set.section || "EXERCISES";
        let group = groups.find((item) => item.section === section);
        if (!group) {
          group = { section, exercises: [] };
          groups.push(group);
        }
        group.exercises.push(
          ...set.exercises.map((exercise) => ({
            ...exercise,
            setTitle: set.title,
          }))
        );
      }
      return groups;
    },
    totalCount() {
      return this.sets.reduce((sum, set) => sum + set.exercises.length, 0);
    },
  },
  methods: {
    sectionLabel(section) {
      const key = `exercises.sections.${section}`;
      return this.$te(key) ? this.$t(key) : section;
    },
    // Um exercicio aberto por vez: a folha com gabarito e comprida.
    toggleExercise(id) {
      this.openId = this.openId === id ? null : id;
    },
  },
  watch: {
    courseClassId: {
      immediate: true,
      handler(id) {
        if (!id) return;
        pitchPartnerApi
          .getLessonAnswerKey(id)
          .then((res) => {
            this.sets = (res.data?.data || []).filter(
              (set) => set.exercises.length
            );
          })
          // Sem exercicios, a aula segue normal: o bloco so nao aparece.
          .catch(() => {
            this.sets = [];
          });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
/* Visao do professor: segue a paleta dele (roxo). */
.lak {
  --accent: var(--dk-grape, #a826e1);
  --ink: var(--dk-ink, #2b2540);
  --muted: var(--dk-muted, #7a7590);

  grid-column: 1 / -1;
  margin-top: 16px;
  border-radius: 16px;
  background: var(--dk-surface, #fff);
  border: 1px solid var(--dk-line, #ece6f5);
  font-family: "Poppins", sans-serif;
}

.lak__toggle,
.lak__row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  border: 0;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.lak__toggle {
  padding: 16px 20px;
}

.lak__toggle:focus-visible,
.lak__row:focus-visible {
  outline: 3px solid rgba(168, 38, 225, 0.3);
  outline-offset: -3px;
  border-radius: 12px;
}

.lak__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
}

.lak__title .mdi {
  color: var(--accent);
}

.lak__count {
  margin-left: auto;
  font-size: 13px;
  color: var(--muted);
}

.lak__chev {
  font-size: 22px;
  color: var(--muted);
}

.lak__body {
  padding: 0 20px 20px;
}

.lak__hint {
  margin: 0 0 12px;
  font-size: 13px;
  color: var(--muted);
}

.lak__section + .lak__section {
  margin-top: 16px;
}

.lak__setname {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--accent);
}

.lak__ex {
  border: 1px solid var(--dk-line, #ece6f5);
  border-radius: 12px;
}

.lak__ex + .lak__ex {
  margin-top: 8px;
}

.lak__ex.is-open {
  border-color: rgba(168, 38, 225, 0.35);
}

.lak__row {
  padding: 12px 14px;
}

.lak__info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1 auto;
}

.lak__prompt {
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
}

.lak__meta {
  font-size: 12px;
  color: var(--muted);
}

.lak__paper {
  padding: 4px 16px 16px;
  border-top: 1px dashed var(--dk-line, #ece6f5);
}

.lak__translation {
  margin: 12px 0 0;
  font-size: 13px;
  font-style: italic;
  color: var(--muted);
}
</style>
